import React from 'react';

import RestrictedGroupListItem from '@/components/Form/components/VisibilitySettings/components/RestrictedVisibilitySettingsSelectedList/components/RestrictedVisibilitySettingsSelectedGroupsList/components/RestrictedGroupListItem';
import useVisibilitySettings from '@/components/Form/components/VisibilitySettings/hooks/useVisibilitySettings';
import useVisibilitySettingsGroups from '@/components/Form/components/VisibilitySettings/hooks/useVisibilitySettingsGroups';

import { RestrictedVisibilitySettingsSelectedGroupsListType } from './types';

const RestrictedVisibilitySettingsSelectedGroupsList: React.FC<
  RestrictedVisibilitySettingsSelectedGroupsListType
> = (props) => {
  const { value, onChange, contextualGroupsConfig, disabled, mode = 'normal' } = props;

  const {
    values,
    methods: { onRemoveGroup },
  } = useVisibilitySettings({ value, onChange, contextualGroupsConfig });

  const { groups } = useVisibilitySettingsGroups({ values, contextualGroupsConfig });

  return (
    <>
      {groups.map((group) => (
        <RestrictedGroupListItem
          key={group.id}
          disabled={disabled}
          group={group}
          mode={mode}
          onRemove={onRemoveGroup}
        />
      ))}
    </>
  );
};

export default RestrictedVisibilitySettingsSelectedGroupsList;
